module.exports = __webpack_public_path__ + "assets/zonejs.b2af65da.svg";